module.exports = __webpack_public_path__ + "static/media/SF-15-A (1).0dd5a30f.mp3";